import { create } from "zustand";
import type { Viewport } from "@xyflow/react";

interface DebateStoreState {
  /** Paper IDs from a clicked camp — used to highlight/filter in Expand page */
  campPaperIds: string[] | null;
  campLabel: string | null;
  setCampFilter: (paperIds: string[], label: string) => void;
  clearCampFilter: () => void;

  /** Persisted viewport so zoom/pan survives navigation */
  viewport: Viewport | null;
  setViewport: (vp: Viewport) => void;

  /** Persisted scroll position for the Analyze page */
  scrollTop: number;
  setScrollTop: (y: number) => void;

  /** Cross-canvas highlight state for split view */
  highlightedPaperIds: string[] | null;
  highlightedClaimId: string | null;
  highlightedCampId: string | null;
  setHighlightedPapers: (ids: string[] | null) => void;
  setHighlightedClaim: (id: string | null) => void;
  setHighlightedCamp: (id: string | null) => void;

}

export const useDebateStore = create<DebateStoreState>((set) => ({
  campPaperIds: null,
  campLabel: null,

  setCampFilter: (paperIds, label) =>
    set({ campPaperIds: paperIds, campLabel: label }),

  clearCampFilter: () => set({ campPaperIds: null, campLabel: null }),

  viewport: null,
  setViewport: (vp) => set({ viewport: vp }),

  scrollTop: 0,
  setScrollTop: (y) => set({ scrollTop: y }),

  highlightedPaperIds: null,
  highlightedClaimId: null,
  highlightedCampId: null,
  setHighlightedPapers: (ids) => set({ highlightedPaperIds: ids }),
  setHighlightedClaim: (id) => set({ highlightedClaimId: id }),
  setHighlightedCamp: (id) => set({ highlightedCampId: id }),

}));
